<template>
  <soha-alert v-if="registered" variant="secondary">
    <div class="mx-2 my-3 font-weight-bolder" v-if="registered">
      <span class="svg svg-icon svg-icon-secondary">
        <inline-svg src="/media/svg/soha/icons/check-1.svg" />
      </span>
      {{ $t(`${I18nPrefix}REGISTERED_MESSAGE`) }}
    </div>
  </soha-alert>
  <div v-else>
    <div class="mt-0 mt-lg-30 mx-xxl-30 mx-0">
      <h1 class="primary-color text-center">
        {{ $t(`${I18nPrefix}PAGE_TITLE`) }}
      </h1>
      <div class="row p-4 m-0">
        <div class="col-12">
          <h3 class="primary-color">
            {{ $t(`${I18nPrefix}PERSONAL_INFORMATION`) }}
          </h3>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}FIRST_NAME`)"
            class="w-100"
            v-model.trim="firstName.value"
            type="text"
            :error="firstName.error"
            name="firstName"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}LAST_NAME`)"
            class="w-100"
            v-model="lastName.value"
            :error="lastName.error"
            type="text"
            name="lastName"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-12 mb-2">
          <soha-select
            class="w-100"
            :placeholder="$t(`${I18nPrefix}GENDER`)"
            name="gender"
            :options="genders"
            v-model="genderId"
            :key="resetKey"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}EMAIL`)"
            class="w-100"
            v-model="email.value"
            :error="email.error"
            type="text"
            name="email"
            autocomplete="new-email"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}MOBILE`)"
            class="w-100"
            v-model="mobile.value"
            :error="mobile.error"
            type="number"
            name="mobile"
            :max-length="11"
            autocomplete="off"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :type="showPass ? 'text' : 'password'"
            name="oldPassword"
            :icon="showPass ? 'hidden' : 'eye'"
            icon-position="left"
            icon-cursor
            @onIconClicked="showPass = !showPass"
            :placeholder="$t(`${I18nPrefix}PASSWORD`)"
            class="w-100"
            v-model="password.value"
            :error="password.error"
            autocomplete="new-password"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :type="showRepeatPass ? 'text' : 'password'"
            name="oldPassword"
            :icon="showRepeatPass ? 'hidden' : 'eye'"
            icon-position="left"
            icon-cursor
            @onIconClicked="showRepeatPass = !showRepeatPass"
            :placeholder="$t(`${I18nPrefix}PASSWORD_REPEAT`)"
            class="w-100"
            v-model="passwordRepeat.value"
            :error="passwordRepeat.error"
            autocomplete="new-password"
          />
        </div>
      </div>
      <div class="row p-4 m-0">
        <div class="col-12">
          <h3 class="primary-color">
            {{ $t(`${I18nPrefix}COMPANY_INFORMATION`) }}
          </h3>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}COMPANY_NAME`)"
            class="w-100"
            v-model.trim="companyName.value"
            type="text"
            :error="companyName.error"
            name="companyName"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}MANAGE_NAME`)"
            class="w-100"
            v-model="manageName"
            type="text"
            name="manageName"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}WEBSITE`)"
            class="w-100"
            v-model="website"
            type="text"
            name="website"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-select
            class="w-100"
            :placeholder="$t(`${I18nPrefix}FIELD`)"
            name="jobCategory"
            :options="jobCategories"
            v-model="selectedField"
            :key="resetKey"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}MEMBER_COUNT`)"
            class="w-100"
            v-model="selectedMemberCount"
            type="number"
            name="memberCount"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-select
            class="w-100"
            :placeholder="$t(`${I18nPrefix}CITY`)"
            name="jobCategory"
            :options="cities"
            v-model="selectedCity"
            :key="resetKey"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            :placeholder="$t(`${I18nPrefix}PHONE`)"
            class="w-100"
            v-model="selectedPhone"
            type="number"
            name="phone"
            :max-length="11"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-2">
          <soha-text-field
            name="dateEstablishment"
            :placeholder="$t(`${I18nPrefix}DATE_ESTABLISHMENT`)"
            class="w-100 date-establishment"
            v-model="dateEstablishment"
            icon="date"
            icon-position="left"
            icon-cursor
            icon-color="secondary"
            readonly
            :key="resetKey"
          />
          <soha-date-picker
            v-model="dateEstablishment"
            custom-input=".date-establishment"
            simple
          />
        </div>
        <div class="col-12 mb-2">
          <soha-text-area
            class="w-100"
            name="address"
            v-model="address"
            :placeholder="$t(`${I18nPrefix}ADDRESS`)"
          />
        </div>
        <div class="col-12 mb-2 py-4 text-center">
          <label class="m-auto cursor-pointer" for="file">
            <div class="soha-company-logo-box">
              <img :src="croppedImage" v-if="croppedImage" />
              <span v-else>
                <inline-svg src="/media/svg/soha/icons/plus.svg" />
                <span class="font-size-sm d-block mt-2">
                  {{ $t(`${I18nPrefix}UPLOAD_LOGO`) }}
                </span>
              </span>
            </div>
            <span
              v-if="croppedImage"
              class="font-size-sm d-block mt-3 secondary-color svg svg-icon svg-icon-secondary"
            >
              {{ $t(`${I18nPrefix}UPLOAD_NEW_LOGO`) }}
            </span>
          </label>
          <input
            id="file"
            ref="file"
            type="file"
            @change="onFileChange"
            accept="image/*"
            v-show="false"
          />

          <soha-modal
            id="crop-image"
            @hide="clearDataModal"
            :title="$t(`${I18nPrefix}CRROPPED_IMAGE`)"
            hide-footer
          >
            <div slot="body">
              <vue-cropper
                v-if="image"
                ref="cropper"
                :src="image"
                style="width: 100%; height: 400px"
                :aspect-ratio="1"
                :fixed-crop-area="true"
              />
              <soha-button
                class="w-100 mt-5"
                name="croppedImage"
                @click="getCroppedImage"
                :text="$t(`${I18nPrefix}CRROPPED_IMAGE`)"
              />
            </div>
          </soha-modal>
        </div>
        <div class="col-lg-12">
          <soha-button
            class="w-100"
            :text="$t(`${I18nPrefix}INSERT`)"
            @click="insertCompany"
            :loading="btnLoading"
          />
        </div>
      </div>
    </div>
    <soha-modal
      id="duplicate-company"
      :title="$t(`${I18nPrefix}DUPLICATE_INFO`)"
    >
      <template v-slot:body>
        <div>
          <soha-alert variant="danger">
            <span class="font-size-h5">
              {{ $t(`${I18nPrefix}DUPLICATE_EMAIL_MOBILE`) }}
            </span>
          </soha-alert>

          <div class="mb-10 w-50 mx-auto">
            <soha-button
              class="w-100"
              :text="$t(`${I18nPrefix}LOGIN`)"
              @click="goToLogin()"
            />
          </div>

          <div class="text-center font-size-h5 mb-2">
            <span>
              {{ $t(`${I18nPrefix}FORGET_PASSWORD_MESSAGE`) }}
            </span>
          </div>
          <div class="w-50 mx-auto">
            <soha-button
              class="w-100"
              :text="$t(`${I18nPrefix}FORGET_PASSWORD`)"
              @click="goToRegister()"
            />
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <div class="w-100">
          <soha-button
            class="w-100"
            :text="$t(`${I18nPrefix}CANCEL`)"
            @click="$bvModal.hide('duplicate-company')"
            variant="danger"
            outline
          />
        </div>
      </template>
    </soha-modal>
  </div>
</template>

<script>
import UIMixin from "@/mixins/UIMixin";
import ApiService from "@/core/services/api.service";
import ValidationMixin from "@/mixins/ValidationMixin";
import GeneralMixin from "@/mixins/GeneralMixin";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
export default {
  name: "PreRegistration",

  mixins: [UIMixin, ValidationMixin, GeneralMixin],

  components: {
    "vue-cropper": VueCropper,
  },

  data() {
    return {
      I18nPrefix: "PAGES.AUTH.PRE_REGISTRATION.",
      firstName: {
        value: null,
        error: null,
      },
      resetKey: 0,
      lastName: {
        value: null,
        error: null,
      },
      mobile: {
        value: null,
        error: null,
      },
      email: {
        value: null,
        error: null,
      },
      password: {
        value: null,
        error: null,
      },
      passwordRepeat: {
        value: null,
        error: null,
      },
      showRepeatPass: false,
      showPass: false,
      companyName: {
        value: null,
        error: null,
      },
      website: null,
      manageName: null,
      jobCategories: [],
      cities: [],
      selectedField: null,
      selectedMemberCount: null,
      selectedCity: null,
      selectedPhone: null,
      dateEstablishment: null,
      address: null,
      btnLoading: false,
      customerPalns: [],
      genderId: null,
      genders: [
        { id: "1", text: "مرد" },
        { id: "2", text: "زن" },
      ],
      image: null,
      croppedImage: null,
      croppedFile: null,
      registered: false,
    };
  },

  mounted() {
    this.getProvinceCities((data) => (this.cities = data));
    this.getJobFields();
  },

  methods: {
    insertCompany() {
      if (this.hasValidationErrors()) return;
      this.btnLoading = true;
      ApiService.post("api/v2/preRegistration", this.createFormData())
        .then((res) => {
          if (res.data.code == 201) {
            this.registered = true;
          } else if (res.data.code == 447) {
            this.$bvModal.show("duplicate-company");
          } else {
            this.errorToast(res.data.message);
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },

    hasValidationErrors() {
      this.firstName.error = this.validateField(
        this.firstName.value,
        this.$t(`${this.I18nPrefix}FIRST_NAME`)
      );
      this.lastName.error = this.validateField(
        this.lastName.value,
        this.$t(`${this.I18nPrefix}LAST_NAME`)
      );
      this.email.error = this.validateEmail(this.email.value);
      this.mobile.error = this.validatePhoneNumber(this.mobile.value);
      this.companyName.error = this.validateField(
        this.companyName.value,
        this.$t(`${this.I18nPrefix}COMPANY_NAME`)
      );
      this.validationPassword();
      return (
        this.firstName.error ||
        this.lastName.error ||
        this.mobile.error ||
        this.email.error ||
        this.companyName.error ||
        this.password.error ||
        this.passwordRepeat.error
      );
    },

    validationPassword() {
      const { value: passwordValue } = this.password;
      const { value: passwordRepeatValue } = this.passwordRepeat;

      this.password.error = this.validatePassword(passwordValue);
      this.passwordRepeat.error =
        !passwordRepeatValue || passwordValue != passwordRepeatValue
          ? this.$t(`${this.I18nPrefix}WRONG_REPEAT_PASSWORD_ERR`)
          : null;
    },

    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },

    createFormData() {
      let formData = new FormData();
      const fields = {
        name: this.companyName.value,
        site: this.website,
        numberEmployees: this.selectedMemberCount,
        jobFieldId: this.selectedField,
        email: this.email.value,
        firstName: this.firstName.value,
        lastName: this.lastName.value,
        mobile: this.mobile.value,
        password: this.password.value,
        cityId: this.selectedCity,
        phone: this.selectedPhone,
        address: this.address,
        dateEstablishment: this.dateEstablishment,
        genderId: this.genderId,
        logo: this.croppedFile,
        manageName: this.manageName,
      };
      Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
      });
      return formData;
    },

    getJobFields() {
      this.jobCategories = [];
      ApiService.get("api/get_job_field").then((res) => {
        res.data.forEach((item) =>
          this.jobCategories.push({ id: item.id, text: item.name })
        );
      });
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (this.validateFile(file)) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.$bvModal.show("crop-image");
      }
    },

    getCroppedImage() {
      const cropper = this.$refs.cropper.getCroppedCanvas({
        width: 90,
        height: 90,
      });
      if (cropper) {
        cropper.toBlob((blob) => {
          const file = new File([blob], "company-logo.jpg", {
            type: "image/jpg",
          });
          this.croppedFile = file;
          this.croppedImage = URL.createObjectURL(blob);
        }, "image/jpg");
      }
      this.$bvModal.hide("crop-image");
    },

    validateFile(file) {
      const validImageTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
      ];

      if (file) {
        if (validImageTypes.includes(file.type)) {
          return true;
        } else {
          this.errorToast("فایل انتخاب شده از نوع تصویر نیست.");
          return false;
        }
      }
      return false;
    },

    clearDataModal() {
      this.image = null;
      this.$refs.file.value = null;
    },

    goToLogin() {
      this.$router.push({ name: "login" });
    },

    goToRegister() {
      this.$router.push({ name: "forget-password" });
    },
  },
};
</script>

<style scoped>
.soha-company-logo-box {
  margin: auto;
  border: 0.153rem solid var(--primary-color);
  width: 6.923rem;
  height: 6.923rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.soha-company-logo-box img {
  width: 100%;
  height: 100%;
}
.soha-company-logo-box svg {
  width: 3rem;
  height: 3rem;
}
</style>
